module.exports = __webpack_public_path__ + "static/media/m_sf_13.912b4c6a.png";